"use client";

import {
	type EcommercePageViewAuthentication,
	addInformation
} from "@pamperedchef/datalayer";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { useConsultantStore, useUserStore } from "@/app/store";
import { isAnalyticsReady } from "@/app/utilities/analytics";

/**
 * Detect device type
 */
function detectDeviceType(userAgent: string): "mobile" | "desktop" {
	return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
		userAgent
	)
		? "mobile"
		: "desktop";
}

/**
 * Page view component
 */
export function PageView(): JSX.Element {
	const pathname = usePathname();
	const userType = useUserStore((state) => state.getUserType());

	const userState = useUserStore((state) => state.userState);
	let userId = "";

	if (
		userState &&
		(userState.type === "customer" || userState.type === "consultant")
	) {
		userId = userState.userId;
	}

	const consultantId = useConsultantStore((state) =>
		state.consultantState.status === "connected"
			? state.consultantState.globalId
			: undefined
	);

	useEffect(() => {
		if (typeof window === "undefined") return;

		if (!isAnalyticsReady()) return;

		const authType =
			userType === "consultant"
				? "consultant"
				: userType === "customer"
					? "consumer"
					: undefined;
		const authentication: EcommercePageViewAuthentication | undefined =
			authType
				? {
						type: authType,
						globalId: userId as string
					}
				: undefined;

		addInformation({
			type: "ecommerce-page-view",
			pagePath: pathname.split("/"),
			layoutType: detectDeviceType(window.navigator.userAgent),
			authentication,
			consultant:
				consultantId !== undefined
					? {
							id: consultantId
						}
					: undefined
		});
	}, [pathname, userId, consultantId, userType]);

	return <></>;
}
